import { Flex } from 'antd';
import { DropDown, IF, Tooltip } from '../../common';
import { HorizontalDotsIcon } from '../../common/all-icons/custom-icons';
import styles from './ActionUtil.module.scss';
import { useState } from 'react';

const ActionRender = ({ filteredActionList, row, renderActionsDirectly }) => {
  const filteredList = filteredActionList?.filter((action) => (action?.hide ? !action?.hide(row) : true)) ?? [];
  const [visible, setVisible] = useState(false);

  const renderButtons = () => {
    return (
      <>
        {filteredList?.map((action, index) => {
          const isBlur = action?.blur ? action?.blur(row) : false;
          const tooltipTitle = action?.tooltip ? action?.tooltip(row) : false;

          const renderAction = () => (
            <Flex
              onClick={(event) => {
                if (isBlur) return;
                setVisible(false);
                action?.onClick(row, event);
              }}
              align="center"
              gap={8}
              className={`${styles.item} ${isBlur && styles.blur}`}
            >
              {action?.icon}
              {action?.renderIcon ? action?.renderIcon(row) : null}
              <IF condition={action?.label}>
                <div className="body-14-medium">{action?.label}</div>
              </IF>
            </Flex>
          );

          if (tooltipTitle) {
            return (
              <Tooltip key={index} title={tooltipTitle}>
                {renderAction()}
              </Tooltip>
            );
          }
          return renderAction();
        })}
      </>
    );
  };

  const DropDownButton = () => {
    return (
      <div className={styles.actionButton}>
        <HorizontalDotsIcon width={13} />
      </div>
    );
  };

  if (renderActionsDirectly) return renderButtons();

  if (!filteredList?.length) return null;

  return (
    <DropDown
      DropDownButton={DropDownButton}
      visible={visible}
      onVisibleChange={(flag) => setVisible(flag)}
      dropdownRender={() => (
        <Flex vertical gap={4} className={styles.actionContainer}>
          {renderButtons()}
        </Flex>
      )}
    />
  );
};

export default ActionRender;
